/**
 * 去除空格
 * @param {*} str 需要处理的字符串
 * @returns
 */
const trim = str => {
    return str.replace(/(^\s*)|(\s*$)/g, '')
}

/**
 * 验证手机号码
 * @param {*} str 手机号码
 * @returns
 */
export const checkPhone = str => {
    let regex = /^1[3|4|5|6|7|8|9][0-9]{9}$/
    if (str.match(regex)) {
        return true
    } else {
        return false
    }
}

/**
 * 保留百分比
 * @param {*} num 需要处理的值
 * @param {*} n 保留几位小数，默认不保留小数
 * @returns
 */
export const retainPercent = (num, n = 0) => {
    let value = Number(num) || 0
    let square = Math.pow(10, n + 2)
    return Math.round(value * square) / Math.pow(10, n) + '%'
}

/**
 * 计算百分比
 * @param {*} seed 被除数
 * @param {*} mother 除数
 * @param {*} n 保留几位小数
 * @returns
 */
export const countPercent = (seed, mother, n = 0) => {
    let dividend = Number.parseFloat(seed) || 0
    let divisor = Number.parseFloat(mother) || 0
    if (divisor === 0) {
        return '0%'
    }
    let consult = dividend / divisor
    let square = Math.pow(10, n + 2)
    return Math.round(consult * square) / Math.pow(10, n) + '%'
}

/**
 * 保留小数
 * @param {*} num 需要处理的值
 * @param {*} n 保留多少位小数，默认位保留2位小数
 * @returns
 */
export const formatNum = (num, n = 2) => {
    let value = Number.parseFloat(num)
    if (n) {
        let square = Math.pow(10, n)
        return Math.round(value * square) / square
    } else {
        return Math.round(value)
    }
}

/**
 * 格式化时间
 * @param {*} str 需要格式化的值
 * @param {*} pattern 时间格式
 * @returns
 */
export const formatDate = (str, pattern = '') => {
    if (!str) { return '' }
    let value = new Date(str)
    let year = value.getFullYear()
    let month = value.getMonth() + 1 + ''
    month = month.padStart(2, '0')
    let day = value.getDate() + ''
    day = day.padStart(2, '0')
    if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return `${year}-${month}-${day}`
    }
    let hour = value.getHours() + ''
    hour = hour.padStart(2, '0')
    let minutes = value.getMinutes() + ''
    minutes = minutes.padStart(2, '0')
    let seconds = value.getSeconds() + ''
    seconds = seconds.padStart(2, '0')
    return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`
}

/**
 * 获取当天日期
 * @param {*} pattern 时间格式，默认'yyyy-mm-dd'
 * @returns
 */
export const getNowDate = (pattern = 'yyyy-mm-dd') => {
    let mydate = new Date()
    let year = mydate.getFullYear()
    let month = mydate.getMonth() + 1 + ''
    month = month.padStart(2, '0')
    if (pattern.toLowerCase() === 'yyyy-mm') {
        return `${year}-${month}`
    }
    let day = mydate.getDate() + ''
    day = day.padStart(2, '0')
    if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return `${year}-${month}-${day}`
    }
    let hour = mydate.getHours() + ''
    hour = hour.padStart(2, '0')
    let minutes = mydate.getMinutes() + ''
    minutes = minutes.padStart(2, '0')
    if (pattern.toLowerCase() === 'yyyy-mm-dd hh:mm') {
        return `${year}-${month}-${day} ${hour}:${minutes}`
    }
    let seconds = mydate.getSeconds() + ''
    seconds = seconds.padStart(2, '0')
    if (pattern.toLowerCase() === 'yyyy-mm-dd hh:mm:ss') {
        return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`
    }
    const weekAry = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    let week = weekAry[mydate.getDay()]
    if (pattern.toLowerCase() === 'yyyy-mm-dd hh:mm:ss e') {
        return `${year}-${month}-${day} ${hour}:${minutes}:${seconds} ${week}`
    }
}

/**
 * 获取前一天日期
 * @returns
 */
export const getBeforeDate = () => {
    const nowdate = new Date().getTime() - 86400000
    const mydate = new Date(nowdate)
    let year = mydate.getFullYear()
    let month = mydate.getMonth() + 1 + ''
    month = month.padStart(2, '0')
    let day = mydate.getDate() + ''
    day = day.padStart(2, '0')
    return `${year}-${month}-${day}`
}

/**
 * 获取浏览器宽高
 * @returns
 */
export const getDomClientSize = () => {
    if (window.innerWidth != null) {
        return {
            width: window.innerWidth,
            height: window.innerHeight
        }
    } else if (document.compatMode === 'CSS1Compat') {
        return {
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight
        }
    }
    return {
        width: document.body.clientWidth,
        height: document.body.clientHeight
    }
}

/**
 * 防抖
 * 在连续的操作中，无论进行了多长时间，
 * 只有某一次的操作后在指定的时间内没有再操作，这一次才被判定有效
 * @param {*} fn 回调函数
 * @param {*} delay 间隔时间
 * @returns
 */
export const Debounce = (fn, delay = 300) => {
    let timer = null;
    return function () {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            fn.apply(this, arguments);
        }, delay);
    }
}

/**
 * 节流
 * 一定时间内一定执行而且只执行一次。我们通常规定300ms执行一下的话，
 * 在规定时间内执行了很多次，只有一次是有效的
 * @param {*} fn 回调函数
 * @param {*} delay 间隔时长
 * @returns
 */
export const Throttle = (fn, delay = 300) => {
    let canRun = true;
    return function () {
        if (!canRun) return;
        canRun = false;
        setTimeout(() => {
            fn.apply(this, arguments);
            canRun = true;
        }, delay);
    };
}